var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrazil(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#459a45",
    d: "M0 0h30v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fedf00",
    d: "M2.47 12 15 20l12.53-8L15 4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#002776",
    d: "M14.9 16.85a5 5 0 1 0 0-10 5 5 0 0 0 0 10"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#cbe9d4",
    d: "M10.49 9.5a5 5 0 0 0-.52 1.56c3.09-.22 7.29 1.47 9.09 3.56a5 5 0 0 0 .68-1.55c-2.22-2.18-6.13-3.59-9.25-3.57"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#88c9f9",
    d: "M10.27 12.09h.78v.77h-.78zm.78 1.55h.77v.77h-.77z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#55acee",
    d: "M12.6 12.09h.77v.77h-.77zm1.54.77h.78v.78h-.78zm3.1 1.55h.78v.77h-.78zm-2.32.77h.77v.78h-.77zm2.32-4.64h.78v.77h-.78z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#3b88c3",
    d: "M15.7 13.64h.77v.77h-.78z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrazil);
export default __webpack_public_path__ + "static/media/brazil.fd68d4a7ea878f57382d191d2bf6fd74.svg";
export { ForwardRef as ReactComponent };